module.exports = {
    settings: {
        switchPicture: '点击更换图片',
        closeStore: '关闭门店',
        openStore: '开启门店',
        edit: '修改门店',
        administrator: '管理员',
        generalMember: '普通成员',
        admin: '管理员',
        general: '普通成员',
        cancel: '取 消',
        sure: '确 定',
        queryText: '请选择用户组',
        store: {
            dialogMsg1: '确定开启当前门店吗?',
            dialogMsg2: '确定关闭当前门店吗?'
        },
        storeInfo: {
            dialogTitle: '修改门店',
            storeName: '门店名称',
            storeId: '门店编号',
            storeAddress: '门店地址',
            cancel: '取 消',
            save: '保 存',
            storeIdMsg: '请输入门店编号',
            storeIdMsg1: '请输入数字或字母',
            storeNameMsg: '请输入门店名称',
            storeAddressMsg: '请输入门店地址',
            success: '修改门店信息成功！',
            fail: '修改门店信息失败！'
        },
        label: { //标签页选项
            memAndAuth: '成员与权限',
            memberManagement: '成员管理',
            userGroupPermissions: '用户组权限',
        },
        optionPage1: { //成员管理
            addMember: '添加成员',
            allMember: '所有',
            generalMember: '普通成员',
            administrator: '管理员',
            table: {
                nickName: '成员姓名',
                name: '用户名',
                group: '用户组',
                state: '状态',
                operation: '操作',
                updatde: '修改',
                delete: '移除',

                generalMember: '普通成员',
                administrator: '管理员',
                valid: '有效',
                invalid: '无效'
            }
        },
        optionPage2: { //用户组权限
            addGroup: '添加用户组',
            sure: '确定',
            cancel: '取消',
            table: {
                operands: '操作对象',
                power: '权限',
                save: '保 存'
            },
            permissions: {
                permissionType: [{
                    type: '商品'
                }, {
                    type: '标签'
                }, {
                    type: '网关'
                }, {
                    type: '模板'
                }, {
                    type: '接口'
                }, ],
                permissionIndex: ['product', 'label', 'gateway', 'template', 'interface'],
                permission: {
                    product: [{
                        name: '新增商品',
                        whether: false,
                        permissionName: '新增商品'
                    }, {
                        name: '修改商品',
                        whether: false,
                        permissionName: '修改商品'
                    }, {
                        name: '删除商品',
                        whether: false,
                        permissionName: '删除商品'
                    }],
                    label: [{
                        name: '新增标签',
                        whether: false,
                        permissionName: '新增标签'
                    }, {
                        name: '删除标签',
                        whether: false,
                        permissionName: '删除标签'
                    }, {
                        name: '标签固件升级',
                        whether: false,
                        permissionName: '固件升级'
                    }, ],
                    gateway: [{
                        name: '新增网关',
                        whether: false,
                        permissionName: '新增网关'
                    }, {
                        name: '修改网关',
                        whether: false,
                        permissionName: '修改网关'
                    }, {
                        name: '删除网关',
                        whether: false,
                        permissionName: '删除网关'
                    }, {
                        name: '网关固件升级',
                        whether: false,
                        permissionName: '固件升级'
                    }],
                    template: [{
                        name: '查看模板',
                        whether: false,
                        permissionName: '查看模板'
                    }, {
                        name: '新增模板',
                        whether: false,
                        permissionName: '新增模板'
                    }, {
                        name: '修改模板',
                        whether: false,
                        permissionName: '修改模板'
                    }, {
                        name: '删除模板',
                        whether: false,
                        permissionName: '删除模板'
                    }],
                    interface: [{
                        name: '思迅接口',
                        whether: false,
                        permissionName: '思迅接口'
                    }, {
                        name: '银豹接口',
                        whether: false,
                        permissionName: '银豹接口'
                    }, {
                        name: '云平台',
                        whether: false,
                        permissionName: '云平台接口'
                    }]
                }
            }
        },
        dialogMsgSetting: {
            cancel: '取 消',
            sure: '确 定',
            open: '开 启',
            close: '关 闭'
        },
        dialogMsg: {
            cancel: '取 消',
            sure: '确 定'
        },
        dialogMsg2: {
            cancel: '取 消',
            sure: '确 定'
        },
        validMsg: { //校验提示信息
            memberName: '请输入成员姓名',
            name: '请输入用户名',
            nameValid: '请输入字母或数字',
            nameExist: '用户已存在',
            nameFail: '获取失败,请重新输入',
            group: '请选择用户组',
            status: '请选择状态',
            password: '请输入密码',
            password2: '请再次输入密码',
            length1: '请输入6-20位密码',
            length2: '请输入6-20位重复密码',
            passRule: '用户密码不能包含空格',
            passRule2: '用户密码不能包含中文',
            disPw: '两次输入密码不一致'
        },
        dialogUpdate: { //修改成员
            dialogTitle: '修 改',
            nickName: '成员姓名',
            name: '用户名',
            group: '用户组',
            state: '状态',
            cancel: '取 消',
            sure: '确 定',
            generalMember: '普通成员',
            administrator: '管理员',
            valid: '有效',
            invalid: '无效',

            nameTip: '请输入成员姓名',
            success: '修改用户成功！',
            noGroup: '修改用户失败，没有此用户组！',
            fail: '修改用户失败！',
            unUpdate: '没有修改管理员权限！'
        },
        dialogAdd: { //添加成员
            dialogTitle: '新 增',
            nickName: '成员姓名',
            name: '用户名',
            group: '用户组',
            state: '状态',
            password: '密码',
            password2: '重复密码',
            generalMember: '普通成员',
            administrator: '管理员',
            valid: '有效',
            invalid: '无效',

            nickNameMsg: '请输入成员姓名',
            nameMsg: '请输入用户名',
            groupMsg: '请选择用户组',
            stateMsg: '请选择状态',
            passwordMsg: '请输入密码',
            passwordMsg2: '请再次输入密码',
            cancel: '取 消',
            sure: '确 定',

            success: '新增用户成功！',
            exist: '用户已存在',
            noGroup: '新增用户失败，没有此用户组！',
            fail: '新增用户失败！'
        },
        queryUser: {
            fail: '查询当前门店用户失败！'
        },
        queryUserToGroup: {
            fail: '查询当前用户组的用户失败！'
        },
        showRole: {
            admin: '管理员',
            general: '普通成员'
        },
        dialogdelete: {
            dialogMsg: '确定移除成员{name}吗?',
            dialogTitle: '移 除',
            success: '移除用户成功！',
            noPermission: '没有移除权限！',
            fail: '移除用户失败！',
            unDelete: '没有移除管理员权限！'
        },
        addGroups: {
            superAdministrator: '超级管理员',
            administrator: '管理员',
            generalMember: '普通成员',
            administrator2: '管理者',
            generalMember2: '正会員',
            // admin:'管理员(admin)',
            // general:'普通成员(user)',
            // superAdministrator2:'Super administrator',
            // administrator2:'Administrator',
            // generalMember2:'Ordinary member',
            // admin2:'Administrator(admin)',
            // general2:'Ordinary member(user)',

            success: '新增用户组成功！',
            exist: '此用户组已存在！',
            fail: '新增用户组失败！',
            // maxLimitNum:"用户组数量已达到上限",
            inputText: '请输入用户组',
            add: '新 增',
            dialogMsg: '确定新增用户组{GroupVal}吗?'
        },
        deleteGroup: {
            dialogMsg: '确定删除该用户组吗?若删除当前用户组,该组内所有成员将重新分配为普通成员！',
            dialogTitle: '删 除',
            success: '删除用户组成功！',
            fail: '删除用户组失败！'
        },
        getGroup: {
            fail: '获取所有角色失败！'
        },
        queryPermission: {
            fail: '获取权限失败！'
        },
        updatePermission: {
            update: '保 存',
            dialogMsg: '是否保存当前用户组权限！',
            success: '修改权限成功！',
            fail: '修改权限失败！'
        },
        hint: {
            // missingRequestParameters:"缺少请求参数",
            openStoreSuccess: "门店开启成功",
            openStoreFail: "门店开启失败",
            closeStoreSuccess: "门店关闭成功",
            closeStoreFail: "门店关闭失败",
            getStoreInfoFail: "获取门店信息失败",
            alreadyExistGroup: "已存在该用户组",
            changeFail: "更换失败",
            internal: "已存在的内置用户组"

            // isNumAndEn:'用户组为纯汉字或纯英文'

        },
        upload: {
            // missingRequestParameters:"缺少请求参数",
            replaceFailed: "图片更换失败！",
            format: '上传头像图片只能是JPG和PNG格式!',
            size: '图片尺寸必须在370*370以内!',
            success: '图片更换成功！',
            failed: '上传图片失败'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/settings.js